module.exports = __webpack_public_path__ + "static/media/ep8.d4dd282e.jpg";